<template>
  <div style="display: flex;flex-direction: column">
    <el-input
      :value="value"
      :placeholder="disabled ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
      type="textarea"
      :rows="4"
      @dblclick.native="onDblclick"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      v-if="selectOperationReqDialog.visible"
      :visible.sync="selectOperationReqDialog.visible"
      lob="AE"
      :value="selectOperationReqDialog.value"
      @callback="onInput"
    />
  </div>
</template>

<script>
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'

export default {
  name: 'AeBasicOperationContent',
  components: { selectOperationReqDialog },
  props: {
    value: { type: String, default: () => '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      selectOperationReqDialog: {
        visible: false,
        value: ''
      }
    }
  },
  methods: {
    onDblclick() {
      this.selectOperationReqDialog.value = this.value
      this.selectOperationReqDialog.visible = !this.disabled
    },
    onInput(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
